import { useEffect, useState } from "react";

export function useClientSide() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);
  return loaded;
}
